export default __webpack_public_path__ + "static/media/logo-small.bdfe354a.png";